export enum TargetGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  ANY = 'ANY',
}
